<template>
  <v-content class="pa-12">
    <v-layout justify-space-around>
      <v-flex
        d-flex
        justify-start
        align-center
        style="color: #3E7662;font-weight: bold;font-size: 24px;"
      >
        <span>จัดการสังกัด</span>
      </v-flex>
      <v-flex d-flex justify-end align-center>
        <v-btn color="#3E7662" dark @click="createPartyModal">
          <span class="mr-2">เพิ่มสังกัด</span>
          <v-icon>add_box</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <!-- Table -->
    <v-layout mt-8>
      <v-flex>
        <form-table
          :headers="headers"
          :items="partyList"
          onViewData
          :edit-party="editParty"
          :del-party="delParty"
        ></form-table>
      </v-flex>
    </v-layout>
    <!-- Pagination -->
    <v-layout mt-12>
      <v-flex>
        <v-pagination
          color="#3E7662"
          :length="paginateParty.last_page"
          :total-visible="9"
          @input="getPartyList"
          v-model="paginateParty.current_page"
        ></v-pagination>
      </v-flex>
    </v-layout>

    <!-- Party modal-->
    <template>
      <v-row justify="center">
        <v-dialog v-model="partyUpdate" persistent max-width="600px">
          <v-card style="background-color: #FAF5F2">
            <!-- Header -->
            <v-card-title class="mb-4">
              <span>แก้ไขสังกัด</span>
            </v-card-title>
            <v-card-text>
              <!-- row 1 -->
              <v-layout px-6>
                <v-flex xs3 mr-3 justify-end align-center d-flex>
                  <span style="font-weight: bold;font-size: 16px;"
                    >ชื่อสังกัด</span
                  >
                </v-flex>
                <v-flex>
                  <v-text-field
                    background-color="#fff"
                    color="#3E7662"
                    v-model="form.partyName"
                    outlined
                    dense
                    hide-details
                  />
                </v-flex>
              </v-layout>
              <!-- row 2 -->
              <v-layout px-6 py-6>
                <v-flex xs3 mr-3 justify-end align-center d-flex>
                  <span style="font-weight: bold;font-size: 16px;"
                    >ชื่อสังกัด<br>ภาษาอังกฤษ</span
                  >
                </v-flex>
                <v-flex>
                  <v-text-field
                    background-color="#fff"
                    color="#3E7662"
                    v-model="form.partyNameEN"
                    outlined
                    dense
                    hide-details
                  />
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions class="mr-12 pb-6">
              <v-spacer></v-spacer>
              <v-btn
                style="font-weight: bold"
                class="mr-2"
                color="#fff"
                @click="partyUpdate = false"
                ><span style="color: #3e7662">ยกเลิก</span></v-btn
              >
              <v-btn
                style="font-weight: bold"
                color="#3E7662"
                dark
                @click="saveParty('update')"
                >บันทึก</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <!-- Party modal-->
    <template>
      <v-row justify="center">
        <v-dialog v-model="partySave" persistent max-width="600px">
          <v-card style="background-color: #FAF5F2">
            <!-- Header -->
            <v-card-title class="mb-4">
              <span>เพิ่มสังกัด</span>
            </v-card-title>
            <v-card-text>
              <!-- row 1 -->
              <v-layout px-6>
                <v-flex xs3 mr-3 justify-end align-center d-flex>
                  <span style="font-weight: bold;font-size: 16px;"
                    >ชื่อสังกัด</span
                  >
                </v-flex>
                <v-flex>
                  <v-text-field
                    background-color="#fff"
                    color="#3E7662"
                    v-model="form.partyName"
                    outlined
                    dense
                    hide-details
                  />
                </v-flex>
              </v-layout>
              <!-- row 1 -->
              <v-layout px-6 py-6>
                <v-flex xs3 mr-3 justify-end align-center d-flex>
                  <span style="font-weight: bold;font-size: 16px;"
                    >ชื่อสังกัด<br>ภาษาอังกฤษ</span
                  >
                </v-flex>
                <v-flex>
                  <v-text-field
                    background-color="#fff"
                    color="#3E7662"
                    v-model="form.partyNameEN"
                    outlined
                    dense
                    hide-details
                  />
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions class="mr-12 pb-6">
              <v-spacer></v-spacer>
              <v-btn
                style="font-weight: bold"
                class="mr-2"
                color="#fff"
                @click="partySave = false"
                ><span style="color: #3e7662">ยกเลิก</span></v-btn
              >
              <v-btn
                style="font-weight: bold"
                color="#3E7662"
                dark
                @click="saveParty('save')"
                >บันทึก</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <loading
      color="#527281"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
    ></loading>
  </v-content>
</template>

<script>
import FormTable from "../../components/table/FormTable";
import Loading from "vue-loading-overlay";
import "vue-select/dist/vue-select.css";
import Swal from "sweetalert2";
import { mapState, mapActions } from "vuex";
export default {
  name: "BudgetResource",
  components: {
    FormTable,
    Loading,
  },
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
    }),
  },
  data: () => ({
    reload: true,
    isLoading: false,
    fullPage: true,
    partyUpdate: false,
    partySave: false,
    partyList: [
      {
        number: 1,
        partyName: "Test 1 ",
        onView: 6,
        linkEdit: "Party",
        id: 1,
      },
    ],
    paginateParty: {
      current_page: 1,
      form: 1,
      last_page: 1,
      per_page: 1,
      total: 1,
      to: 1,
    },
    headers: [
      {
        text: "ลำดับ",
        value: "number",
        align: "center",
        width: "5%",
        sortable: false,
      },
      { text: "ชื่อสังกัด", value: "partyName", align: "center" },
      { text: "ชื่อสังกัดภาษาอังกฤษ", value: "partyNameEN", align: "center" },
      {
        text: "แก้ไข",
        value: "edit",
        align: "center",
        width: "5%",
        sortable: false,
      },
      {
        text: "ลบ",
        value: "delete",
        align: "center",
        width: "5%",
        sortable: false,
      },
    ],
    form: {
      id: "",
      partyName: "",
        partyNameEN: ""
    },
  }),
  created() {
    // Check Permission Access
    //    if (this.user.currentRole !== 1) {
    //        this.$router.go(-1);
    //   }
    this.getPartyList(1);
  },
  methods: {
    getPartyList(page) {
      // this.isLoading = true;
      this.partyList = [];
      this.$store
        .dispatch("Common/getPartyList", page)
        .then((res) => {
          console.log("PArty", res);
          this.isLoading = false;
          let i = 1;
          res.data.forEach((data) => {
            this.partyList.push({
              number: i,
              id: data.id,
              partyName: data.affiliation,
                partyNameEN: data.affiliationEN,
              linkEdit: "Party",
              onView: 6,
            });
            i++;
          });
          this.paginateParty.current_page = res.current_page;
          this.paginateParty.form = res.form;
          this.paginateParty.last_page = res.last_page;
          this.paginateParty.per_page = res.per_page;
          this.paginateParty.total = res.total;
          this.paginateParty.to = res.to;
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    createPartyModal() {
      this.form.partyName = "";
      this.form.partyNameEN = "";
      this.partySave = true;
    },
    editParty(item) {
      console.log(item);
      this.form.id = item.id;
      this.form.partyName = item.partyName;
      this.form.partyNameEN = item.partyNameEN;
      this.partyUpdate = true;
    },
    saveParty(name) {
      if (name === "save") {
        console.log("zzzzzz");
        let data = {
          affiliation: this.form.partyName,
          affiliationEN: this.form.partyNameEN,
        };
        console.log(data);
        this.isLoading = true;
        this.$store
          .dispatch("Common/saveParty", data)
          .then((res) => {
            this.isLoading = false;
            Swal.fire({
              title: "บันทึกเรียบร้อยแล้ว",
              icon: "success",
              position: "center",
              showConfirmButton: false,
              confirmButtonColor: "#3E7662",
              timer: 1500,
            }).then(() => {
              this.partySave = false;
              this.getPartyList(1);
            });
          })
          .catch((e) => {
            this.isLoading = false;
            if (e.response.data.errors) {
              for (var k in e.response.data.errors) {
                Swal.fire({
                  title: "เกิดข้อผิดพลาด",
                  text: e.response.data.errors[k][0],
                  icon: "warning",
                  confirmButtonColor: "#3E7662",
                }).then(() => {
                  this.$vuetify.goTo(`#${k}`);
                });
              }
            }
            // this.isLoading = false;
            // Swal.fire({
            //     title: "เกิดข้อผิดพลาด",
            //     text: "บันทึกไม่สำเร็จ",
            //     confirmButtonColor: '#3E7662',
            //     icon: 'warning'
            // });
          });
      } else {
        console.log("sssss");
        let data = {
          id: this.form.id,
          affiliation: this.form.partyName,
            affiliationEN: this.form.partyNameEN
        };
        this.isLoading = true;
        this.$store
          .dispatch("Common/updateParty", data)
          .then((res) => {
            this.isLoading = false;
            Swal.fire({
              title: "บันทึกเรียบร้อยแล้ว",
              icon: "success",
              position: "center",
              showConfirmButton: false,
              confirmButtonColor: "#3E7662",
              timer: 1500,
            }).then(() => {
              this.partyUpdate = false;
              this.getPartyList(1);
            });
          })
          .catch((e) => {
            this.isLoading = false;
            Swal.fire({
              title: "เกิดข้อผิดพลาด",
              text: "บันทึกไม่สำเร็จ",
              confirmButtonColor: "#3E7662",
              icon: "warning",
            });
          });
      }
    },
    delParty(id) {
      Swal.fire({
        title: "คุณต้องการลบข้อมูลหรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ต้องการ",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("Common/deleteParty", id)
            .then(() => {
              Swal.fire({
                title: "ลบข้อมูลเรียบร้อยแล้ว",
                icon: "success",
                position: "center",
                showConfirmButton: false,
                timer: 1500,
              });
            })
            .then(() => {
              this.getPartyList(this.paginateParty.current_page);
            })
            .catch((e) => {
              Swal.fire({
                title: "เกิดข้อผิดพลาด",
                text: "ลบข้อมูลไม่สำเร็จ",
                icon: "warning",
              });
            });
        }
      });
    },
  },
};
</script>

<style lang="scss">
table th + th {
  border-left: 1px solid #dddddd;
}
table td + td {
  border-left: 1px solid #dddddd;
}
.table {
  th.text-center.sortable {
    font-weight: bold;
    font-size: 16px;
  }
}
.table {
  th.text-left.sortable {
    font-weight: bold;
    font-size: 16px;
  }
}
table thead tr th {
  text-align: center !important;
}
tbody tr td {
  color: #544a44;
}
table tbody tr td {
  text-align: left !important;
}
thead.v-data-table-header tr th {
  span {
    color: #000;
    font-size: 14px;
  }
}
</style>
